
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { AuthentificationService } from "projects/hp-api/src/lib/services/authentification-service.service";
import { UserService } from "projects/hp-api/src/lib/services/user.service";
import { Location, DOCUMENT } from '@angular/common';
import { AlertService } from 'projects/hp-api/src/lib/services/alert.service'
import { Component, ElementRef, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy,Inject, Renderer2 } from '@angular/core';
import { AppComponent } from 'projects/hp-api/src/lib/app-entry/app.component';

@Component({
  selector: 'app-root',
  templateUrl: '../../../hp-api/src/lib/app-entry/app.component.html',
  styleUrls: [
    '../../../hp-api/src/lib/app-entry/app.component.scss'
  
  ],
  host: {'class': 'belm'}
})
export class AppComponentBelm extends AppComponent {
  
  constructor( @Inject(DOCUMENT) document: Document,
    renderer: Renderer2, chgDetectorRef: ChangeDetectorRef, hpService: HpService,
    authentificationService: AuthentificationService,
    userService: UserService,
    alertService: AlertService,
    route: ActivatedRoute,  
    router: Router, 
    location: Location,  
    dialog: MatDialog,
    elRef: ElementRef) {

      super(document, renderer, chgDetectorRef, hpService,authentificationService, userService, alertService, route, router, location, dialog, elRef);
     
  }
}
